
  Vue.component('seeker-lists-summary', {
    data() {
      return {}
    },
    pinia: Vue.pinia,
    template: '#seeker-lists-summary',
    computed: {
      // seekerListsStore data
      ...Pinia.mapState(useSeekerListsStore, {
        lists: store => store.lists,
        selectedList: store => store.selectedList
      })
    },
    watch: {},
    methods: {
      // seekerListsStore actions
      ...Pinia.mapActions(useSeekerListsStore, ['addToList', 'removeFromList', 'selectList'])
    },
    mounted() {}
  })
